module.exports = __webpack_public_path__ + "fonts/euclid-square-700-italic.16d03a64.ttf";